import HtmlIcon from "../Assets/icons/html5.png";
import CssIcon from "../Assets/icons/css3.png";
import JavascriptIcon from "../Assets/icons/javascript.png";
import TypescriptIcon from "../Assets/icons/typescript.png";
import ReactIcon from "../Assets/icons/react.png";
import ReduxIcon from "../Assets/icons/redux.png";
import RectRouterIcon from "../Assets/icons/react-router.png";
import NextIcon from "../Assets/icons/next-js.png";
import GatsbyIcon from "../Assets/icons/gatsby-js.png";
import NodeIcon from "../Assets/icons/node-js.png";
import MongoDBIcon from "../Assets/icons/mongo-db.png";
import JestIcon from "../Assets/icons/jest.png";
import ReactTestingLibraryIcon from "../Assets/icons/react-testing-library.png";
import CypressIcon from "../Assets/icons/cypress.png";
import SassIcon from "../Assets/icons/sass.png";
import StyledComponentsIcon from "../Assets/icons/styled-components.png";
import StorybookIcon from "../Assets/icons/storybook.png";
import BootstrapIcon from "../Assets/icons/bootstrap.png";
import AdobeXDIcon from "../Assets/icons/adobe-xd.png";
import GitIcon from "../Assets/icons/git.png";
import WebpackIcon from "../Assets/icons/webpack.png";
import TailwindIcon from "../Assets/icons/tailwind.png";
import MaterialUiIcon from "../Assets/icons/material-ui.png";
import DockerIcon from "../Assets/icons/docker.png";

export const skillsData = [
  { title: "HTML 5", icon: HtmlIcon, color: "#E44D26" },
  { title: "CSS 3", icon: CssIcon, color: "#0170BA" },
  { title: "Javascript", icon: JavascriptIcon, color: "#E6CF1C" },
  { title: "Typescript", icon: TypescriptIcon, color: "#3178C6" },
  { title: "React JS", icon: ReactIcon, color: "#61DAFB" },
  { title: "Next JS", icon: NextIcon, color: "#000000" },
  { title: "Gatsby JS", icon: GatsbyIcon, color: "#663399" },
  { title: "Redux", icon: ReduxIcon, color: "#764ABC" },
  { title: "React-Router", icon: RectRouterIcon, color: "#CA4245" },
  { title: "Styled Components", icon: StyledComponentsIcon, color: "#FBC334" },
  { title: "Sass", icon: SassIcon, color: "#CD6799" },
  { title: "Storybook", icon: StorybookIcon, color: "#FF4785" },
  { title: "Tailwind", icon: TailwindIcon, color: "#11CDB6" },
  { title: "Material UI", icon: MaterialUiIcon, color: "#00B0FF" },
  { title: "Bootstrap", icon: BootstrapIcon, color: "#8812FC" },
  { title: "Jest", icon: JestIcon, color: "#C63D14" },
  { title: "React Testing Library", icon: ReactTestingLibraryIcon, color: "#FC4544" },
  { title: "Cypress", icon: CypressIcon, color: "#5C5C5E" },
  { title: "Node JS", icon: NodeIcon, color: "#5CA44C" },
  { title: "Mongo DB", icon: MongoDBIcon, color: "#402E1E" },
  { title: "Git", icon: GitIcon, color: "#000000" },
  { title: "Webpack", icon: WebpackIcon, color: "#1C78C0" },
  { title: "Docker", icon: DockerIcon, color: "#2497ED" },
  { title: "Adobe XD", icon: AdobeXDIcon, color: "#CC4EC5" },
];
